import { Button, Table, Tag, Wrapper, useBreadcrumbRoutes } from '@maxtropy/components';
import { ColumnsType } from 'antd/es/table';
import { useState } from 'react';
import RecordDetailModal from './components/RecordDetailModal';
import styles from './index.module.scss';

export type RecordStatus = 'issued' | 'cancelled' | 'unconfirmed';

export interface OperationRecordItem {
  id: number;
  suggestedExecutionTime: string;
  overallSuggestedValue: string;
  issuedValue: string;
  status: RecordStatus;
  operator: string;
  operationTime: string;
}

const records: OperationRecordItem[] = [
  {
    id: 1,
    suggestedExecutionTime: '2026-07-08 16:00:00',
    overallSuggestedValue: '22500.16',
    issuedValue: '22490.16',
    status: 'issued',
    operator: 'admin',
    operationTime: '2026-07-08 16:00:00',
  },
  {
    id: 2,
    suggestedExecutionTime: '2026-07-08 16:00:00',
    overallSuggestedValue: '22500.16',
    issuedValue: '22480.16',
    status: 'cancelled',
    operator: 'admin',
    operationTime: '2026-07-08 16:00:00',
  },
  {
    id: 3,
    suggestedExecutionTime: '2026-07-08 16:00:00',
    overallSuggestedValue: '22500.16',
    issuedValue: '22523.16',
    status: 'unconfirmed',
    operator: 'admin',
    operationTime: '2026-07-08 16:00:00',
  },
  {
    id: 4,
    suggestedExecutionTime: '2026-07-08 16:00:00',
    overallSuggestedValue: '22500.16',
    issuedValue: '22517.16',
    status: 'issued',
    operator: 'admin',
    operationTime: '2026-07-08 16:00:00',
  },
  {
    id: 5,
    suggestedExecutionTime: '2026-07-08 16:00:00',
    overallSuggestedValue: '22500.16',
    issuedValue: '22500.16',
    status: 'issued',
    operator: 'admin',
    operationTime: '2026-07-08 16:00:00',
  },
  {
    id: 6,
    suggestedExecutionTime: '2026-07-08 16:00:00',
    overallSuggestedValue: '22500.16',
    issuedValue: '22500.16',
    status: 'issued',
    operator: 'admin',
    operationTime: '2026-07-08 16:00:00',
  },
];

const statusConfig: Record<RecordStatus, { text: string; color: 'success' | 'error' | 'warning' }> = {
  issued: { text: '已下发', color: 'success' },
  cancelled: { text: '已取消', color: 'error' },
  unconfirmed: { text: '未确认', color: 'warning' },
};

const LoadDispatchOperationRecord = () => {
  const routesContext = useBreadcrumbRoutes();
  const [selectedRecord, setSelectedRecord] = useState<OperationRecordItem>();

  const columns: ColumnsType<OperationRecordItem> = [
    {
      title: '建议执行时间',
      dataIndex: 'suggestedExecutionTime',
      width: 220,
    },
    {
      title: '总体建议值',
      dataIndex: 'overallSuggestedValue',
      width: 130,
    },
    {
      title: '下发值',
      dataIndex: 'issuedValue',
      width: 130,
    },
    {
      title: '状态',
      dataIndex: 'status',
      width: 100,
      render: (status: RecordStatus) => {
        const config = statusConfig[status];
        return (
          <Tag border="solid" color={config.color} className={styles.statusTag}>
            {config.text}
          </Tag>
        );
      },
    },
    {
      title: '操作人',
      dataIndex: 'operator',
      width: 130,
    },
    {
      title: '操作时间',
      dataIndex: 'operationTime',
      width: 220,
    },
    {
      title: '下发详情',
      key: 'action',
      width: 90,
      render: (_, record) => (
        <Button type="link" className={styles.viewButton} onClick={() => setSelectedRecord(record)}>
          查看
        </Button>
      ),
    },
  ];

  return (
    <Wrapper routes={[...(routesContext?.routes ?? []), { name: '负荷调度操作记录' }]} hasPadding={false}>
      <main className={styles.page}>
        <Table rowKey="id" columns={columns} dataSource={records} pagination={false} scroll={{ x: 1000 }} />
      </main>
      <RecordDetailModal
        open={Boolean(selectedRecord)}
        record={selectedRecord}
        onCancel={() => setSelectedRecord(undefined)}
      />
    </Wrapper>
  );
};

export default LoadDispatchOperationRecord;
